export const es = {
    // Navbar & Sidebar
    navigation: {
        dashboard: 'Panel de Control',
        agents: 'Mis Agentes',
        masterAgents: 'Gestión Total',
        agentPerformance: 'Performance Agentes',
        rules: 'Reglas de Pago',
        mappings: 'Mapeos de Columnas',
        consolidation: 'Consolidación',
        processor: 'Procesar Comisiones',
        reconciliation: 'Conciliación',
        unassigned: 'Agentes sin Registrar',
        subscription: 'Suscripción',
        profile: 'Mi Cuenta',
        clientsActive: 'Todos los Activos',
        clientsCanceled: 'Todos los Cancelados',
        clients: 'Clientes',
        bookOfBusiness: 'Book of Business',
        dailyActivity: 'Actividad Diaria',
        tasks: 'Tareas y Notas',
        messagesMenu: 'Mensajes',
        bookUpload: 'Subir Book of Business',
        myDashboard: 'Mi Dashboard',
        myClients: 'Mis Clientes',
        myReconciliation: 'Mi Conciliación',
        myAgency: 'Mi Agencia',
        independent: 'Independiente',
        login: 'Iniciar Sesión',
        logout: 'Cerrar Sesión',
        home: 'Inicio',
        agency: 'Agencia',
        payments: 'Pagos a Agentes',
        settings: 'Configuración Default'
    },
    // Dashboard
    dashboard: {
        title: 'Centro de Mando',
        subtitle: 'Vista financiera global',
        months: {
            1: 'Enero', 2: 'Febrero', 3: 'Marzo', 4: 'Abril', 5: 'Mayo', 6: 'Junio',
            7: 'Julio', 8: 'Agosto', 9: 'Septiembre', 10: 'Octubre', 11: 'Noviembre', 12: 'Diciembre'
        },
        noData: 'No hay datos en este periodo',
        stats: {
            grossRevenue: 'Ingreso Bruto',
            agentPayout: 'Pago Agentes',
            netRevenue: 'Utilidad Neta',
            policiesMembers: 'Pólizas / Miembros'
        },
        charts: {
            carrierPerformance: 'Rendimiento por Carrier',
            topProducers: 'Top Producers',
            policies: 'pólizas',
            revenueTrend: 'Tendencia de Ingresos (6 meses)'
        },
        errorLoading: 'Error cargando analíticas',
        vsPrevMonth: 'vs mes anterior',
        pending: {
            title: 'Cuenta Pendiente de Aprobación',
            description: 'Gracias por registrar tu agencia. Para garantizar la seguridad y calidad de nuestra red, todas las cuentas de agencia requieren una validación manual o una demostración.',
            nextSteps: 'Próximos Pasos:',
            step1: 'Nuestro equipo revisará tu NPN ({npn})',
            step2: 'Te contactaremos al correo registrado',
            step3: 'Una vez aprobado, tendrás acceso total',
            contactSupport: 'Contactar Soporte',
            backHome: 'Volver al Inicio'
        },
        loadCsv: 'Cargar CSV',
        downloadPdf: 'Descargar Reporte PDF',
        pdfGenerated: 'PDF generado exitosamente',
        historicalOverview: 'Resumen Histórico General',
        allTimeData: 'Datos acumulados de todos los periodos',
        allTime: 'Histórico total',
        agents: 'agentes'
    },
    // Agents
    agents: {
        title: 'Mis Agentes',
        subtitle: 'Gestiona tu equipo de productores y sus permisos',
        invite: 'Invitar Agente',
        import: 'Importar Masivamente',
        searchPlaceholder: 'Buscar por nombre o email...',
        table: {
            agent: 'Agente',
            email: 'Email',
            status: 'Estado',
            joined: 'Se unió',
            actions: 'Acciones'
        },
        status: {
            active: 'Activo',
            pending: 'Pendiente'
        },
        empty: {
            title: 'No hay agentes registrados',
            description: 'Comienza invitando a tu primer agente o importa una lista.'
        },
        inviteDialog: {
            title: 'Invitar Nuevo Agente',
            description: 'Envía una invitación por correo electrónico para que se unan a tu agencia.',
            emailLabel: 'Correo Electrónico',
            send: 'Enviar Invitación',
            sending: 'Enviando...'
        },
        importDialog: {
            title: 'Importar Agentes CSV',
            step1: 'Subir Archivo',
            step2: 'Mapear Columnas',
            step3: 'Previsualizar',
            dragDrop: 'Arrastra y suelta tu archivo CSV aquí',
            selectFile: 'Seleccionar Archivo'
        }
    },
    // Clients
    clients: {
        active: {
            title: 'Clientes Activos',
            subtitle: '{count} clientes activos en total',
            stats: {
                total: 'Total Activos',
                newThisMonth: 'Nuevos este Mes',
                topCarrier: 'Top Carrier'
            }
        },
        canceled: {
            title: 'Clientes Cancelados',
            subtitle: '{count} clientes cancelados en total',
            stats: {
                total: 'Total Cancelados',
                canceledThisMonth: 'Cancelados este Mes'
            }
        },
        table: {
            searchPlaceholder: 'Buscar por nombre, correo o teléfono...',
            allCarriers: 'Todos los Carriers',
            allAgents: 'Todos los Agentes',
            headers: {
                client: 'Cliente',
                agent: 'Agente',
                email: 'Correo',
                carrier: 'Aseguradora',
                policyId: 'ID Póliza',
                startDate: 'Fecha Inicio',
                status: 'Estado'
            },
            pagination: {
                showing: 'Mostrando {start} a {end} de {total}',
                page: 'Página {current} de {total}'
            },
            empty: {
                noResults: 'No se encontraron resultados',
                noClients: 'No hay clientes'
            }
        },
        status: {
            active: 'Activo',
            inactive: 'Inactivo',
            pending: 'Pendiente',
            canceled: 'Cancelado'
        },
        actions: {
            refresh: 'Actualizar',
            viewFull: 'Ver completo',
            history: 'Historial',
            notes: 'Notas',
            documents: 'Documentos'
        }
    },
    // Profile
    profile: {
        title: 'Mi Cuenta',
        subtitle: 'Gestiona la información de tu agencia',
        info: {
            title: 'Información del Perfil',
            subtitle: 'Actualiza la foto y datos de tu agencia'
        },
        form: {
            agencyName: 'Nombre de la Agencia',
            npn: 'NPN (National Producer Number)',
            phone: 'Teléfono',
            email: 'Correo Electrónico',
            emailHelper: 'El correo no puede modificarse por seguridad'
        },
        save: 'Guardar Cambios',
        saving: 'Guardando...',
        account: {
            title: 'Información de la Cuenta',
            type: 'Tipo de Cuenta',
            typeValue: 'Agencia / Broker',
            status: 'Estado',
            statusValue: 'Cuenta Activa',
            memberSince: 'Miembro desde {date}'
        },
        success: 'Perfil actualizado correctamente',
        error: 'Error al actualizar el perfil'
    },
    // Procesador
    processor: {
        title: 'Procesador de Archivos',
        subtitle: 'Importa, procesa y distribuye leads y pólizas automáticamente',
        newProcess: 'Nuevo Proceso',
        steps: {
            upload: 'Subir',
            config: 'Configurar',
            preview: 'Previsualizar',
            process: 'Procesar',
            results: 'Resultados'
        },
        upload: {
            title: 'Sube tu archivo CSV del Carrier',
            description: 'Arrastra y suelta tu archivo aquí o haz clic para explorar.',
            button: 'Seleccionar Archivo CSV',
            autoDetect: 'Auto-detectar columnas',
            cleaning: 'Limpieza de datos',
            mapping: 'Asignación inteligente',
            history: 'Historial seguro'
        },
        config: {
            title: 'Configuración del Proceso',
            description: 'Define cómo procesar este archivo y a qué carrier pertenece',
            carrier: 'Carrier',
            insuranceType: 'Tipo de Seguro',
            month: 'Mes del Reporte',
            year: 'Año del Reporte',
            selectCarrier: 'Selecciona Carrier',
            selectType: 'Selecciona Tipo',
            selectMonth: 'Selecciona Mes',
            selectYear: 'Selecciona Año',
            autoAssign: 'Asignación Automática',
            autoAssignDesc: 'Asignar clientes a agentes basados en NPN del archivo',
            fileSummary: 'Resumen del Archivo',
            rows: 'Filas',
            cols: 'Columnas',
            size: 'Tamaño',
            back: 'Atrás',
            continue: 'Continuar a Previsualización'
        },
        status: {
            processing: 'Procesando...',
            success: 'Procesamiento exitoso',
            error: 'Error en el procesamiento'
        }
    },
    // Landing & Public
    landing: {
        heroTitle: 'Un Precio Justo. Acceso Total.',
        heroSubtitle: 'Sin complicaciones. Elige tu perfil y comienza.',
        agencyTitle: 'Agencia PRO',
        agencyDescription: 'Control total para dueños y administradores.',
        agencyPrice: '$39.99',
        agencyPriceUnit: '/mes',
        agencyButton: 'Suscribir Agencia',
        agentTitle: 'Agente Independiente',
        agentDescription: 'Transparencia total para productores.',
        agentPrice: '$39.99',
        agentFeatures: {
            portal: 'Portal Personal de Comisiones',
            tracking: 'Rastreo de Pagos en Tiempo Real',
            history: 'Historial de Producción',
            alerts: 'Alertas de Depósito'
        }
    },
    // Conciliación
    reconciliation: {
        title: 'Conciliación de Comisiones',
        subtitle: 'Sube archivos de comisiones y concilia contra tu base de datos',
        uploadTitle: 'Cargar Reporte CSV del FMO',
        mappingTitle: 'Mapear Columnas del CSV',
        steps: {
            upload: 'Subir Archivo',
            mapping: 'Mapeo',
            results: 'Resultados'
        },
        filters: {
            agent: 'Filtrar por Agente',
            carrier: 'Filtrar por Carrier',
            month: 'Mes',
            year: 'Año',
            apply: 'Aplicar Filtros',
            clear: 'Limpiar'
        },
        stats: {
            totalRows: 'Total Registros',
            matched: 'Conciliados',
            unmatched: 'No Encontrados',
            discrepancy: 'Con Diferencia'
        },
        table: {
            policy: 'Póliza',
            agent: 'Agente',
            client: 'Cliente',
            premium: 'Prima',
            carrier: 'Carrier',
            product: 'Producto',
            effectiveDate: 'Fecha Efec.',
            status: 'Estado',
            commission: 'Comisión',
            action: 'Acción'
        },
        status: {
            matched: 'Conciliado',
            unmatched: 'No Encontrado',
            discrepancy: 'Diferencia',
            pending: 'Pendiente'
        },
        actions: {
            save: 'Guardar Conciliación',
            new: 'Nueva Conciliación',
            download: 'Descargar Reporte',
            details: 'Ver Detalles'
        },
        toasts: {
            unsupportedFormat: 'Formato no soportado',
            useCsv: 'Por favor, sube un archivo CSV o Excel',
            emptyFile: 'Archivo vacío',
            fileLoaded: 'Archivo cargado correctamente',
            rowsFound: 'filas encontradas',
            parseError: 'Error al leer archivo',
            missingColumn: 'Columna requerida faltante',
            selectPolicyColumn: 'Debes seleccionar la columna de Policy Number',
            configError: 'Error de configuración',
            userNotFound: 'No se encontró la información del usuario',
            reconciliationSuccess: '¡Conciliación perfecta!',
            allPoliciesMatched: 'Todas las pólizas aparecieron en el reporte',
            discrepanciesFound: 'pólizas sin pago detectadas',
            saveSuccess: '¡Conciliación guardada exitosamente!',
            noDataToExport: 'No hay datos para exportar'
        }
    },
    // Mapeos
    mappings: {
        title: 'Configurar Mapeos de Columnas',
        subtitle: 'Configura los mapeos de columnas por carrier para que tus agentes puedan usar estos preajustes.',
        form: {
            insuranceType: 'Tipo de Seguro',
            carrier: 'Selecciona el Carrier',
            name: 'Nombre del Mapeo (Opcional)',
            namePlaceholder: 'Ej: Ambetter 2024',
            configured: 'Mapeos Configurados',
            statusField: 'Campo de Status',
            inactiveValues: 'Valores para Inactivo'
        },
        alerts: {
            selectType: 'Primero selecciona el tipo de seguro',
            selectCarrier: 'Primero selecciona un carrier',
            noMappings: 'No hay mapeos configurados'
        },
        file: {
            upload: 'Arrastra un archivo CSV de ejemplo',
            description: 'Solo necesitamos ver las columnas, no procesaremos los datos',
            detected: 'Columnas detectadas en tu archivo:'
        },
        tips: {
            insuranceType: 'Selecciona el tipo de seguro (Medicare, ACA o Privado). Cada tipo puede tener mapeos diferentes.',
            carrier: 'Este mapeo será específico para este carrier. Los agentes asociados podrán usarlo.',
            name: 'Asigna un nombre personalizado a este mapeo para identificarlo fácilmente.',
            statusField: 'Selecciona qué columna CSV indica si el cliente está activo o inactivo',
            inactiveValues: 'Agrega los valores que aparecen en la columna de status cuando el cliente está inactivo',
            customColumns: 'Agrega columnas adicionales que quieras capturar de este carrier'
        },
        labels: {
            statusField: 'Campo de Status (Obligatorio)',
            inactiveValues: 'Valores que indican Cliente Inactivo',
            customColumns: 'Columnas Personalizadas',
            required: 'Obligatorio',
            newColumn: 'Nueva Columna',
            csvColumn: 'Nombre de columna CSV',
            field: 'Nombre del campo',
            addColumn: 'Agregar Columna'
        },
        success: 'Mapeo guardado exitosamente'
    },
    // Reglas
    rules: {
        title: 'Reglas de Pago',
        subtitle: 'Configura cómo se calculan las comisiones por carrier y producto',
        newRule: 'Nueva Regla',
        table: {
            insuranceType: 'Tipo Seguro',
            agent: 'Agente (NPN)',
            carrier: 'Carrier',
            state: 'Estado',
            product: 'Producto',
            type: 'Tipo',
            payout: 'Pago Agente',
            allAgents: 'Todos los Agentes',
            internal: 'Solo Internos',
            external: 'Solo Externos',
            allProducts: 'Todos los productos',
            allStates: 'Todos'
        },
        dialog: {
            newTitle: 'Nueva Regla de Pago',
            editTitle: 'Editar Regla de Pago',
            targetGroup: 'Aplicar regla a:',
            insuranceType: 'Tipo de Seguro',
            carrier: 'Carrier',
            product: 'Producto',
            wildcard: 'Aplicar a TODOS los productos de este Carrier',
            state: 'Estado',
            calculationType: 'Tipo de Cálculo',
            agentValue: 'Valor del Agente',
            save: 'Guardar Regla'
        },
        empty: {
            title: 'No hay reglas configuradas',
            description: 'Crea tu primera regla para calcular comisiones automáticamente',
            button: 'Crear Primera Regla'
        },
        tips: {
            targetGroup: 'Define a qué grupo de agentes se aplicará esta regla',
            insuranceType: 'Selecciona el tipo de seguro (Medicare, ACA o Privado)',
            agentNpn: 'Ingresa el NPN del agente al que se aplicará esta regla específica',
            product: 'Si dejas este campo vacío, la regla SOLO aplicará cuando el Excel no traiga producto (NULL/Vacío)',
            wildcard: 'La regla aplicará a cualquier producto del Carrier',
            state: 'Si no seleccionas un estado, la regla aplicará a todos los estados',
            remainder: 'La agencia recibirá automáticamente el remanente (Total - Pago Agente)',
            calcExampleFixed: 'Ejemplo: Si hay 5 miembros y la regla es $10 por miembro, el agente recibirá $50 (5 × $10). La agencia recibirá el resto del total.',
            calcExamplePercentage: 'Ejemplo: Si el total recibido es $100 y el agente cobra 70%, el agente recibirá $70 y la agencia $30 automáticamente.'
        },
        form: {
            percentage: 'Porcentaje del Total (%)',
            fixed: 'Fijo por Miembro ($)',
            agentValue: 'Valor Agente',
            selectAgentGroup: 'Selecciona a quién aplicar la regla',
            selectState: 'Selecciona un estado (opcional)'
        }
    },
    // Agentes sin Asignar
    unassigned: {
        title: 'Agentes sin Registrar',
        subtitle: 'Comisiones de agentes que aún no tienen cuenta en el sistema',
        stats: {
            agents: 'Agentes sin registrar',
            total: 'Total acumulado',
            records: 'Registros pendientes'
        },
        alert: {
            title: 'Hay comisiones pendientes de asignar',
            description: 'Estos agentes tienen comisiones procesadas pero no están registrados. Invítalos para que puedan ver sus pagos.'
        },
        table: {
            npn: 'NPN',
            carriers: 'Carriers',
            records: 'Registros',
            total: 'Total Acumulado',
            action: 'Acción'
        },
        invite: 'Invitar',
        listTitle: 'Lista de Agentes',
        toasts: {
            updated: 'Datos actualizados',
            inviteSent: 'Invitación enviada',
            inviteSentDesc: 'Se envió una invitación al agente con NPN',
            loadError: 'Error al cargar datos'
        },
        empty: {
            title: '¡Todo en orden!',
            description: 'Todos los agentes con comisiones están registrados en el sistema'
        }
    },
    // Planes de Suscripción
    subscriptionPlans: {
        title: 'Planes de Suscripción',
        subtitle: 'Elige el plan que mejor se adapte a tus necesidades',
        currentSubscription: 'Suscripción Actual',
        plan: 'Plan',
        expires: 'Expira',
        manageSubscription: 'Gestionar Suscripción',
        status: {
            active: 'Activa',
            trialing: 'Prueba',
            past_due: 'Vencida',
            canceled: 'Cancelada',
            incomplete: 'Incompleta'
        },
        agentTitle: 'Agente Independiente',
        agentDescription: 'Todo lo que necesitas para gestionar tus ventas',
        agentPrice: '$39.99',
        agentPriceUnit: '/mes',
        agentFeatures: {
            portal: 'Portal de Comisiones',
            tracking: 'Rastreo de Pagos',
            history: 'Historial Completo',
            alerts: 'Alertas por Email'
        },
        agentButton: 'Suscribirme Ahora',
        agentButtonActive: 'Tu Plan Actual',
        agentButtonRedirecting: 'Redirigiendo...',
        agencyTitle: 'Agencia Partner',
        agencyDescription: 'Soluciones a medida para agencias en crecimiento',
        agencyPrice: 'Personalizado',
        agencyPriceSubtext: 'Contacta para cotización',
        agencyFeatures: {
            multiUser: 'Gestión Multi-Usuario',
            import: 'Importación Masiva',
            support: 'Soporte Prioritario',
            agents: 'Gestión de Agentes'
        },
        agencyButton: 'Solicitar Acceso',
        footer: {
            guarantee: 'Garantía de satisfacción de 30 días.',
            cancel: 'Puedes cancelar en cualquier momento.'
        }
    },
    common: {
        loading: 'Cargando...',
        error: 'Error',
        success: 'Éxito',
        cancel: 'Cancelar',
        save: 'Guardar',
        delete: 'Eliminar',
        edit: 'Editar',
        unknown: 'Desconocido',
        selectFile: 'Seleccionar Archivo',
        dragDrop: 'Arrastra y suelta tu archivo aquí',
        processing: 'Procesando...',
        back: 'Volver',
        upload: 'Subir',
        close: 'Cerrar',
        refresh: 'Actualizar',
        agencyNotFound: 'Agencia no encontrada'
    },
    // Landing Page (public)
    landingNav: {
        login: 'Iniciar Sesión',
        register: 'Registrarme',
        features: 'Beneficios',
        pricing: 'Precios',
        contact: 'Contacto'
    },
    hero: {
        titleStart: 'La Plataforma Definitiva para',
        titleHighlight: 'Conciliación de Comisiones',
        subtitle: 'Domina tus finanzas, elimina errores y automatiza tu conciliación. Consoliday transforma el caos de Excel en claridad financiera en segundos.',
        ctaPrimary: 'Empezar Ahora',
        ctaSecondary: 'Ver Demo'
    },
    features: {
        title: '¿Por qué elegir Consoliday?',
        subtitle: 'Diseñado por expertos en seguros para agencias y agentes.',
        f1Title: 'Conciliación Automática',
        f1Desc: 'Sube tus archivos de comisiones y deja que nuestro motor inteligente encuentre discrepancias al instante.',
        f2Title: 'Gestión de Agentes',
        f2Desc: 'Centraliza la información de tu equipo, asigna niveles jerárquicos y controla pagos downstream fácilmente.',
        f3Title: 'Reportes en Tiempo Real',
        f3Desc: 'Visualiza tus ingresos, proyecciones y estado de pagos con dashboards interactivos y exportables.',
        f4Title: 'Seguridad Bancaria',
        f4Desc: 'Tus datos están protegidos con encriptación de última generación y cumplimiento de normas de privacidad.'
    },
    pricing: {
        title: 'Planes Transparentes',
        subtitle: 'Elige el plan que se adapte a tu crecimiento.',
        month: '/mes',
        popular: 'POPULAR',
        agency: {
            title: 'Agencia',
            price: 'Contáctanos',
            features: [
                'Plataforma de Gestión Integral',
                'Incentiva la productividad de tus Agentes',
                'Monitoreo de Ventas en Tiempo Real',
                'Gestión Jerárquica de Equipo',
                'Reportes Consolidados Automáticos'
            ],
            btn: 'Solicitar Demo'
        },
        agent: {
            title: 'Agente Independiente',
            price: '$39.99',
            features: [
                'Dashboard personal',
                'Rastreo de comisiones propias',
                'Alertas de pagos',
                'Historial de pólizas',
                'Soporte por email'
            ],
            btn: 'Comenzar Ahora'
        }
    },
    footer: {
        rights: 'Todos los derechos reservados.',
        privacy: 'Privacidad',
        terms: 'Términos'
    }
};
